// import React from "react";
// import {
//   Button,
//   Card,
//   CardHeader,
//   CardBody,
//   CardFooter,
//   Label,
//   FormGroup,
//   Form,
//   Alert,
//   Input,
  
//   InputGroupText,
//   InputGroup,
//   Container,
//   Col,
//   Row,
// } from "reactstrap";
// import cookie from "react-cookies";
// import axios from "axios";
// import "components/custom.css";
// import API from "api.js";
// import { store, persistor } from "store/index";
// import { setSub } from "action/index.js";
// // import NotificationAlert from "react-notification-alert";
// import { Navigate, NavLink, Link } from "react-router-dom";
// import ReactGA from "react-ga";
// import ReactPixel from "react-facebook-pixel";
// import successIcon from "assets/images/images_new/success-icon.png";


// class SubSuccess extends React.Component {
//   constructor(props) {
//     super(props);
//     const urlParams = new URLSearchParams(window.location.search);
//     this.state = {
//       interval: null,
//       mode: urlParams.get("mode"),
//     };
//   }

//   componentDidMount() {
//     const urlParams = new URLSearchParams(window.location.search);
//     const p = urlParams.get("p");
//     const currency = urlParams.get("currency");
//     const mode = urlParams.get("mode");

//     ReactGA.initialize("UA-157984080-1");
//     ReactGA.pageview(window.location.pathname + window.location.search);
//     ReactGA.ga("event", "conversion", {
//       send_to: "AW-796233751/328VCNOGi5QZEJeg1vsC",
//       value: p,
//       currency: currency,
//       transaction_id: "",
//     });

//     
//     // ReactPixel.init("197333187452630");
//     ReactPixel.track("Purchase", { value: p, currency: "USD" });

//     //var inter = setInterval(this.checkSub, 3000);
//     //this.setState({interval:inter});
//     var element = document.getElementsByClassName("wrapper-full-page");
//     if (element.length > 0) {
//       element[0].classList.add("full-height");
//       element[0].classList.remove("wrapper-full-page");
//     }
//     document
//       .getElementsByTagName("body")[0]
//       .classList.add("leftSidebarClosed", "package-payment-page");
//   }

//   componentWillUnmount() {
//     document
//       .getElementsByTagName("body")[0]
//       .classList.remove("leftSidebarClosed", "package-payment-page");
//   }

//   checkSub = async () => {
//     let res = null;
//     try {
//       res = await API({
//         method: "GET",
//         url: "check/payment",
//       });
//     } catch (error) {}
//     if (res.status === 200) {
//       clearInterval(this.state.interval);
//       store.dispatch(setSub(true));
//     }
//   };

//   render() {
//     // if(!localStorage.getItem('paySuccessStatus')){
//     //   console.log('you are inside of IF');
//     //   return <Navigate to={'/admin/plans'} replace />;
//     // }
//     const msg =
//       this.state.mode === "razorpay" ? (
//         <p>
//           You have subscribed successfully. <br />
//           Your subscription will be active in few minutes. Please login again
//           after few minutes.
//         </p>
//       ) : (
//         <p>
//           You have subscribed successfully. <br />
//           Please return to the Dashboard to access the new features.
//         </p>
//       );

//     return (
//       // <div className="col-xs-12 successContent">
//       //   <img
//       //     src="/images/subscription-success.png"
//       //     alt="subscription-success"
//       //   />
//       //   <h2>Subscription Successful00!</h2>
//       //   <p>{msg}</p>
//       // </div>
//           <>
//           <div className="transation-page payment-successful outer-wrapper w-75">
//             <div className="successful-content">
//               <img src={successIcon} alt="LA" />
//               <h2>Payment successful</h2>
//               <p>Transaction was successful <br /> and your subscription is now active</p>
//               <div className="payment-btns">
//                 <Link className="pay-btn dashboard-btn" to={"/admin/dashboard"}>Go To Dashboard</Link>
//                 <Link className="pay-btn manage-btn" to={"/admin/plans"}>Manage Plan</Link>
//               </div>
//             </div>
//           </div>
//           <br /> 
//         </>      
//     );
//   }
// }

// export default SubSuccess;


import React, { useEffect, useState, useRef } from "react";
import "components/custom.css";
import API from "api.js";
import { store, persistor } from "store/index";
import { setSub } from "action/index.js";
// import NotificationAlert from "react-notification-alert";
import { Navigate, NavLink, Link } from "react-router-dom";
import ReactGA from "react-ga";
import ReactPixel from "react-facebook-pixel";
import successIcon from "assets/images/images_new/success-icon.png";
// import cookie from "react-cookies";
// import axios from "axios";
// import { current } from "@reduxjs/toolkit";


const SubSuccess = (props) => {
  const urlParams = new URLSearchParams(window.location.search);
  const [interval, setInterval] = useState(null);
  const [mode, setMode] = useState(urlParams.get("mode"));
  const intervalRef = useRef(null);
  const [price, setPrice] = useState(urlParams.get("p"));
  const [currency, setCurrency] = useState(urlParams.get("currency"));

  const checkSub = async () => {
    let res = null;
    try {
      res = await API({
        method: "GET",
        url: "check/payment",
      });
    } catch (error) {}
    if (res.status === 200) {
      clearInterval(intervalRef.current);
      store.dispatch(setSub(true));
      store.dispatch(setRegionAccess(true));
    }
  };

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const p = urlParams.get("p");
    const currency = urlParams.get("currency");
    const mode = urlParams.get("mode");

    setMode(mode);
    setPrice(p);
    setCurrency(currency);

    console.log("p====",p);
    console.log("currency==",currency);
    console.log("mode===",mode);

    ReactGA.initialize("UA-157984080-1");
    ReactGA.pageview(window.location.pathname + window.location.search);
    ReactGA.ga("event", "conversion", {
      send_to: "AW-796233751/328VCNOGi5QZEJeg1vsC",
      value: p,
      currency: currency,
      transaction_id: "",
    });

    
    // ReactPixel.init("197333187452630");
    ReactPixel.track("Purchase", { value: p, currency: "USD" });

    //var inter = setInterval(checkSub, 3000);
    //intervalRef.current = inter;
    var element = document.getElementsByClassName("wrapper-full-page");
    if (element.length > 0) {
      element[0].classList.add("full-height");
      element[0].classList.remove("wrapper-full-page");
    }
    document
      .getElementsByTagName("body")[0]
      .classList.add("leftSidebarClosed", "package-payment-page");

    // Cleanup function (componentWillUnmount)
    return () => {
      document
        .getElementsByTagName("body")[0]
        .classList.remove("leftSidebarClosed", "package-payment-page");
    };
  }, []);

  // if(!localStorage.getItem('paySuccessStatus')){
  //   console.log('you are inside of IF');
  //   return <Navigate to={'/admin/plans'} replace />;
  // }
  const msg =
    mode === "razorpay" ? (
      <p>
        You have subscribed successfully. <br />
        Your subscription will be active in few minutes. Please login again
        after few minutes.
      </p>
    ) : (
      <p>
        You have subscribed successfully. <br />
        Please return to the Dashboard to access the new features.
      </p>
    );

  return (
    // <div className="col-xs-12 successContent">
    //   <img
    //     src="/images/subscription-success.png"
    //     alt="subscription-success"
    //   />
    //   <h2>Subscription Successful00!</h2>
    //   <p>{msg}</p>
    // </div>
        <>
        <div className="transation-page payment-successful outer-wrapper">
          <div className="successful-content">
            <img src={successIcon} alt="LA" />
            <h2>Payment successful</h2>
            <p>Your subscription for {price}{currency} has been successfully processed.</p>
            <p>Your subscription will be activated soon.<br/> Please login again
            after few minutes.</p>
            <div className="payment-btns">
              <Link className="pay-btn dashboard-btn" to={"/admin/dashboard"}>Go To Dashboard</Link>
              <Link className="pay-btn manage-btn" to={"/admin/plans"}>Manage Plan</Link>
            </div>
          </div>
        </div>
        <br /> 
      </>      
  );
};

export default SubSuccess;
